import { useQuery } from 'react-query';
import services from 'services/services';

// Import helpers
import { DROP_OFF_CITIES_QUERY } from 'helpers';

const useDropOffCities = (place_id) => {
	const url = `/v1/content/cities/drop-list`;

	const { data, isFetching } = useQuery(
		[DROP_OFF_CITIES_QUERY, place_id],
		async () => await services.post(url, { place_id }),
		{ refetchOnWindowFocus: false }
	);

	const fetchedData = data?.data.data || [];

	return { data: fetchedData, isFetching };
};

export default useDropOffCities;
